import React from 'react';

// Read-only display for multi-line text typed into a textarea: each line
// break starts a new paragraph with a 0.5-line gap above it, and extra blank
// lines collapse into that same gap. Use in place of `whiteSpace: 'pre-line'`.
function ParagraphText({ text, style }) {
  const paragraphs = String(text ?? '').split(/\n+/).filter((p) => p.trim());
  return (
    <div style={style}>
      {paragraphs.map((para, i) => (
        <div key={i} style={i > 0 ? { marginTop: '0.5em' } : undefined}>{para}</div>
      ))}
    </div>
  );
}

export default ParagraphText;
